import { Dropdown } from '@common/components';
import { SvgKebab } from '@common/icon';

interface ReviewCardMenuProps {
  onEdit: () => void;
  onDelete?: () => void;
}

export const ReviewCardMenu = ({ onEdit, onDelete }: ReviewCardMenuProps) => {
  return (
    <Dropdown.Root dir="rtl">
      <Dropdown.Trigger asChild>
        <button type="button" aria-label="옵션" className="-m-16 p-16">
          <SvgKebab className="size-16" />
        </button>
      </Dropdown.Trigger>
      <Dropdown.Content className="z-10 mt-4 min-w-150 rounded-xsmall bg-Gray-white shadow-xl">
        <Dropdown.Item
          className="px-16 py-8 font-400 text-Gray-900 transition-all duration-300 typo-body3 hover:bg-Gray-100"
          role="button"
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
        >
          수정
        </Dropdown.Item>
        {onDelete && (
          <Dropdown.Item
            className="px-16 py-8 font-400 text-R-500 transition-all duration-300 typo-body3 hover:bg-Gray-100"
            role="button"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            삭제
          </Dropdown.Item>
        )}
      </Dropdown.Content>
    </Dropdown.Root>
  );
};
